import React, { useEffect, useRef, useState } from "react";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { OrderGetList } from "../../services/ReduxTookit/Slice/OrderRedux";
import Nodata from "../../component/common-component/Nodata";
import { commonservices } from "../../services/CommonServices";
import viewaction from "../../assets/images/viewaction.svg";
import OrderDetailsModal from "./OrderDetailsModal";

const OrderManagementModal = () => {
  const dispatch = useDispatch();
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const payloadRef = useRef();

  const closeShowOrderDetails = () => {
    setShowOrderDetails(false);
  };

  const getOrderList = async () => {
    setLoading(true);
    dispatch(OrderGetList())
      .then((response) => {
        if (response?.payload?.isValidate) {
          setOrderList(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setOrderList([]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getOrderList();
  }, []);

  return (
    <>
      <div className="table-wrapper-main setting-table-main">
        <div className="profile-common-title"></div>
        <Table responsive>
          <thead>
            <tr>
              <th>Order No.</th>
              <th className="text-center">Date</th>
              <th className="text-center">Order Item</th>
              <th>Status</th>
              <th className="text-end">Price</th>
              <th className="text-end">Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <Loader type={LoaderType.TableRow} count={6} nooftd={6} />
            ) : (
              <>
                {orderList?.length > 0 ? (
                  <>
                    {orderList?.map((item) => {
                      return (
                        <tr key={item?.orderno}>
                          <td className="text-start">{item?.orderno}</td>
                          <td className="text-center">
                            {item?.orderdate
                              ? commonservices.getDateInFormatCustom(
                                  item?.orderdate,
                                  null,
                                  "MM/DD/yyyy"
                                )
                              : ""}
                          </td>
                          <td className="text-center">
                            {item?.orderitemscount}
                          </td>
                          <td>{commonservices.getStatus(item?.status_term)}</td>
                          <td className="text-end">
                            {item?.orderamount > 0
                              ? `$${item?.orderamount?.toFixed(2)}`
                              : "Free"}
                          </td>

                          <td className="sticky-actions">
                            <div className="all-actions">
                              <img
                                src={viewaction}
                                onClick={() => {
                                  payloadRef.current = {
                                    orderId: item?.orderid,
                                  };
                                  setShowOrderDetails(true);
                                }}
                                alt="viewaction"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    {/* <tr>
                      <td colSpan={4} className="text-right bold-black">
                        Total
                      </td>
                      <td className="text-end">
                        <span>
                          Quantity:{" "}
                          <strong className="bold-black">
                            {orderList?.length}
                          </strong>
                        </span>
                        |
                        <span>
                          Amount:{" "}
                          <strong className="bold-black">
                            {orderList.reduce(
                              (total, item) => total + item?.orderitemscount,
                              0
                            )}
                          </strong>
                        </span>
                      </td>
                    </tr> */}
                  </>
                ) : (
                  <tr>
                    <td colSpan={100}>
                      <Nodata />
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </Table>
      </div>
      {showOrderDetails && (
        <OrderDetailsModal
          showModal={showOrderDetails}
          closeModal={closeShowOrderDetails}
          payload={payloadRef.current}
        />
      )}
    </>
  );
};

export default OrderManagementModal;
